// This file was generated using `pay js:run gql-v1 --type=fragment --name=StripeAccountUnificationAccountController --dir=path/to/dir`.
// To generate yours, do not copy and paste; use the command above instead. Do not delete this comment.

/* eslint-disable @stripe-internal/data-v1/camel-case-alias */

import {gql} from '@sail/data';

import type {GraphQlDocument, GraphQlFragmentUnion} from '@sail/data';
import type {
  Exact,
  OpenapiAccountUnificationAccountControllerTypeEnum,
} from '@stripe-internal/data-v1/schema/types';
import type {V1PermissionToken} from '@stripe-internal/data-v1/types';
import {stripeAccountUnificationAccountControllerApplicationFragment} from './stripeAccountUnificationAccountControllerApplicationFragment';
import {stripeAccountUnificationAccountControllerDashboardFragment} from './stripeAccountUnificationAccountControllerDashboardFragment';
import {stripeAccountUnificationAccountControllerLossesFragment} from './stripeAccountUnificationAccountControllerLossesFragment';

import type {StripeAccountUnificationAccountControllerApplicationFragmentData} from './stripeAccountUnificationAccountControllerApplicationFragment';
import type {StripeAccountUnificationAccountControllerDashboardFragmentData} from './stripeAccountUnificationAccountControllerDashboardFragment';

import type {StripeAccountUnificationAccountControllerLossesFragmentData} from './stripeAccountUnificationAccountControllerLossesFragment';

const doc = gql`
  fragment StripeAccountUnificationAccountControllerFragment on OpenapiAccountUnificationAccountController {
    application {
      ...StripeAccountUnificationAccountControllerApplicationFragment
    }
    dashboard {
      ...StripeAccountUnificationAccountControllerDashboardFragment
    }
    losses {
      ...StripeAccountUnificationAccountControllerLossesFragment
    }
    is_controller
    type
  }

  ${stripeAccountUnificationAccountControllerApplicationFragment}
  ${stripeAccountUnificationAccountControllerDashboardFragment}
  ${stripeAccountUnificationAccountControllerLossesFragment}
`;

export const stripeAccountUnificationAccountControllerFragment: StripeAccountUnificationAccountControllerFragmentDocument =
  doc;

// THIS IS AUTOGENERATED CODE, DO NOT EDIT AS YOUR CHANGES WILL BE BLOWN AWAY
// Regenerate it using eslint in fix mode.

export type StripeAccountUnificationAccountControllerFragmentData = {
  readonly __typename: 'OpenapiAccountUnificationAccountController';
  readonly is_controller: boolean | null;
  readonly type: OpenapiAccountUnificationAccountControllerTypeEnum;
  readonly application: GraphQlFragmentUnion<
    {
      readonly __typename: 'OpenapiAccountUnificationAccountControllerApplication';
    },
    [StripeAccountUnificationAccountControllerApplicationFragmentData]
  > | null;
  readonly dashboard: GraphQlFragmentUnion<
    {
      readonly __typename: 'OpenapiAccountUnificationAccountControllerDashboard';
    },
    [StripeAccountUnificationAccountControllerDashboardFragmentData]
  > | null;
  readonly losses: GraphQlFragmentUnion<
    {readonly __typename: 'OpenapiAccountUnificationAccountControllerLosses'},
    [StripeAccountUnificationAccountControllerLossesFragmentData]
  > | null;
};

export type StripeAccountUnificationAccountControllerFragmentVariables = Exact<{
  [key: string]: never;
}>;

const stripeAccountUnificationAccountControllerFragmentPermissions = {
  ...stripeAccountUnificationAccountControllerApplicationFragment.permissions,
  ...stripeAccountUnificationAccountControllerDashboardFragment.permissions,
  ...stripeAccountUnificationAccountControllerLossesFragment.permissions,
} as const;

doc.permissions = stripeAccountUnificationAccountControllerFragmentPermissions;

export type StripeAccountUnificationAccountControllerFragmentPermissions =
  V1PermissionToken<
    typeof stripeAccountUnificationAccountControllerFragmentPermissions
  >;

export type StripeAccountUnificationAccountControllerFragmentDocument =
  GraphQlDocument<
    StripeAccountUnificationAccountControllerFragmentData,
    StripeAccountUnificationAccountControllerFragmentVariables,
    StripeAccountUnificationAccountControllerFragmentPermissions
  >;
